module.exports = __webpack_public_path__ + "img/gameshow7.4bee4053.svg";